<template>
  <div>
    <organism-all-event
      v-if="!isLoading && filterData"
      v-model="datepicker"
      :filterList="filterData"
      :equipmentList="equipmentList"
      :tagList="tagList"
      :resourceTypeList="resourceTypeList"
      :fields="fields"
      :items="eventList"
      @onUpdateFilterData="onUpdateFilterData"
      @onSetDefaultFilterData="onSetDefaultFilterData"
    ></organism-all-event>
  </div>
</template>

<script>
import OrganismAllEvent from "@/components/organisms/OrganismAllEvent.vue"
import {
  getHostname,
  getTags,
  getResourceTypes,
  getAllEvents,
} from "@/api/api-module"
import mixins from "@/mixins"
import mixinsDateTime from "@/mixins/mixinsDatetime"
import { DateTime } from "luxon"
import { mapActions, mapGetters } from "vuex"
import mixinsObjectHelper from '@/mixins/mixinsObjectHelper'
export default {
  name: "AllEvents",
  components: {
    OrganismAllEvent,
  },
  mixins: [mixins, mixinsDateTime, mixinsObjectHelper],
  data() {
    return {
      filterTags: [],
      filterResourceTypes: [],
      datepicker: {
        start: "",
        end: "",
        now: "",
      },
      equipmentList: [],
      tagList: [],
      resourceTypeList: [],
      fields: [
        {
          field: "time",
          label: "TIME",
          sortable: true,
          thClass: "pl-2",
        },
        {
          field: "equipment",
          label: "EQUIPMENT",
          sortable: true,
        },
        {
          field: "resources",
          label: "RESOURCES",
          sortable: true,
        },
        {
          field: "value",
          label: "VALUE",
          sortable: true,
        },
        {
          field: "description",
          label: "DESCRIPTION",
          sortable: false,
        },
      ],
      eventList: [],
      filterData: null,
    }
  },
  computed: {
    ...mapGetters("appFilter", ["getSMSAllEventFilter"]),

    isLoading() {
      return (
        !this.equipmentList.length &&
        !this.tagList.length &&
        !this.resourceTypeList.length
      )
    },
  },
  async mounted() {
    await this.getHostnameList()
    await this.getTagList()
    await this.getResourceTypeList()
    await this.getEventList()
  },
  methods: {
    ...mapActions("appFilter", ["setSMSAllEventFilter"]),

    cloneFilterDataFromVuex() {
      const filterDataFromVuex = this.getSMSAllEventFilter
      this.filterData = this.deepCopyObject(filterDataFromVuex)
    },

    // get equipment list
    async getHostnameList() {
      this.showLoading(true)
      this.equipmentList = []
      await getHostname().then((response) => {
        this.equipmentList = response
      }).finally(() => this.showLoading(false))
    },

    // get tags list
    async getTagList() {
      this.showLoading(true)
      this.tagList = []
      await getTags().then((response) => {
        this.tagList = response
      }).finally(() => this.showLoading(false))
    },

    // get resource types list
    async getResourceTypeList() {
      this.showLoading(true)
      this.resourceTypeList = []
      await getResourceTypes().then((response) => {
        this.resourceTypeList = response
      }).finally(() => this.showLoading(false))
    },

    // get resource types list
    async getEventList() {
      this.showLoading(true)
      this.cloneFilterDataFromVuex()
      await getAllEvents(
        this.removeTimeZone(this.filterData.from),
        this.removeTimeZone(this.filterData.to),
        this.filterData.equipments,
        this.filterData.resourceTypes,
        this.filterData.tags
      ).then((response) => {
        this.eventList = response.map((event) => {
          return {
            id: event.eventId,
            date: DateTime.fromISO(event.timestamp).toFormat("dd/MM/yyyy"),
            time: DateTime.fromISO(event.timestamp).toFormat("HH:mm:ss"),
            equipmentName: event.equipmentName,
            tag: event.tags,
            equipmentIp: event.equipmentIpAddress,
            resources: event.resourceType,
            value:
              parseFloat(event.value) < 0.1
                ? "< 0.1"
                : parseFloat(event.value).toFixed(1),
            warningValue: parseFloat(event.warningValue).toFixed(2),
            criticalValue: parseFloat(event.criticalValue).toFixed(2),
            policyUnit: event.unit,
            status: event.status,
            description: event.equipmentDescription,
          }
        })
      }).finally(() => this.showLoading(false))
    },

    // click filter
    onUpdateFilterData(filter) {
      this.setSMSAllEventFilter(filter)
      this.getEventList()
    },

    onSetDefaultFilterData() {
      const defaultFilter = {
        from: DateTime.now().minus({ days: 1 }).toISO(),
        to: DateTime.now().toISO(),
        equipments: [],
        resourceTypes: [],
        tags: [],
      }
      this.setSMSAllEventFilter(defaultFilter)
      this.getEventList()
    },

    onFetchingData() {
      this.getEventList()
    },
  },
}
</script>

<style lang="scss" scoped></style>
